import Constants from "../../core/libraries/Constants";
import Helper from "../../core/libraries/Helper";
import { FeberApiClient } from "../../services/commonServices";


export const getDocumentTypes = (uploadType: string) => {
    let data:any[]=[]
    data.push.apply(data, Constants.DOCUMENT_TYPE_MASTER_DATA[uploadType]);
    return data;
}

export const getConfigurations =()=>{
    return 5;
}

export const uploadReport  = async (report:any,mode:string)=>{
    try {
        let payload = Helper.prepareUploadPayload(report,mode);
    let response =await (await FeberApiClient.post("Upload/UploadReport"
    ,{...payload}
    ,{
        headers:{
            'Content-Type': 'multipart/form-data'
          },
          timeout:600000
    })).data
    return !!response&& !!response.success;     
    } catch (error) {
        console.log(error);
        return false
    }
}